/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {useNavigate, useParams} from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
/* Components */
import FormDocuments from "../../../forms/admin/FormDocuments";
import Header from "../../../components/common/Header";
import {getDocumentInfos} from "../../../api/admin/documentReq";
import useAuth from "../../../hooks/useAuth";
import Missing from "../../Missing";
import {PDFViewer} from "@react-pdf/renderer";
import TiptapView from "../../../components/common/input-layout/tiptap/TiptapView";
import Icon from "../../../components/common/Icon";


export default function ViewDocumentInfos() {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const { documentInfos, setDocumentInfos } = useData();
    const documentsPath = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL + "/documents/";
    const navigate = useNavigate();
    const [ showModal, setShowModal ] = useState(false);
    const [ forceHideModal, setForceHideModal ] = useState(false);
    const apiDocumentInfos = async () => {
        const response = await getDocumentInfos(token, id)
            setDocumentInfos(response);
    }

    const handleDocumentForm = () => {
        setShowModal(true)
    };

    useEffect(() => {
        apiDocumentInfos();
    }, [ id ]);

    return (
        <main>
            { (documentInfos?.error && id!=0) &&
                <Missing />
            }
            { (!documentInfos.error || id ==0) &&
                <>

                    <Header parent="Documents"
                            location={(id !== 0)
                                ? "Modification d'un document "
                                : "Ajout d'un document "}
                            locationComp={`${documentInfos && documentInfos.name ? documentInfos.name : ""}`}
                            slug="/admin/documents"
                    />
                    {((id == 0 && forceHideModal == false) || showModal) &&
                        <div className="modal document-infos">
                            <FormDocuments apiDocumentInfos={apiDocumentInfos} setShowModal={setShowModal} legend={id == 0 ? `Ajout d'un document` : `Modification d'un document`}/>
                        </div>
                    }
                    <div className="double-fieldset document-infos-fieldset">
                        <fieldset>
                            <Icon source="fa fa-file-lines" span="Informations d'un document"/>
                            <div className="form-input">
                                <label>Nom du document</label>
                                <span>{documentInfos?.name}</span>
                            </div>
                            <div className="form-input html-textarea view">
                                <label>Description</label>
                                <TiptapView content={documentInfos?.description}/>
                            </div>
                            <div className="form-input">
                                <label>Date de création</label>
                                <span>{documentInfos?.createdAt}</span>
                            </div>
                            <div className="form-input">
                                <label>Date de mise à jour</label>
                                <span>{documentInfos?.updatedAt}</span>
                            </div>
                            <div className="form-input">
                                <label>Url du document</label>
                                <a href={documentInfos?.url}>{documentInfos?.url ? documentInfos?.url : "Pas d'url"}</a>
                            </div>
                            <div className="buttons-container back">
                                <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                            </div>
                        </fieldset>
                        <fieldset className="preview">
                            {documentInfos?.fileName && documentInfos?.fileName.includes(".pdf") ?
                                <div className="form-input html-textarea document-view">
                                    <label>Aperçu</label>
                                    <PDFViewer
                                        width="100%"
                                        height="100%"
                                        src={`${documentsPath}${documentInfos?.fileName}`}
                                    />
                                </div> :
                                documentInfos?.url ?
                                    <div className="form-input html-textarea document-view">
                                        <label>Aperçu</label>
                                        <iframe
                                            src={documentInfos?.url}
                                            width="100%"
                                            height="100%"
                                            title="Document"
                                        />
                                    </div> :
                                    <div className="form-input html-textarea document-view">
                                        <label>Aperçu</label>
                                        <span>Pas de document</span>
                                    </div>
                            }
                            <div className="buttons-container">
                                <button className="red-button" onClick={handleDocumentForm}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                            </div>
                        </fieldset>
                    </div>
                </>
            }
        </main>
    );
}